import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { AuthProvider } from './contexts/AuthContext.jsx'
import { AnnouncerProvider } from './contexts/AnnouncerContext.jsx'
import App from './App.jsx'
import './styles/global.css'

const container = document.getElementById('root')
const root = createRoot(container)
root.render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <AnnouncerProvider>
          <App />
        </AnnouncerProvider>
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>
)
